import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'kbDateFormat',
    standalone: false
})
export class kbDateFormatPipe implements PipeTransform {
    transform(value: any): any {
        if (!value) {
            return null;
        }
        const date = new Date(value);
        const day = this.addLeadingZero(date.getDate());
        const month = this.addLeadingZero(date.getMonth() + 1);
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }

    private addLeadingZero(value: number): string {
        return value < 10 ? `0${value}` : `${value}`;
    }
}
